import React, { useContext } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../context';
import { FaArrowRightFromBracket } from "react-icons/fa6";
import { SubmitSession } from './Timer';

const UserLogout = () => {
    const { setState, setIsToggled } = useContext(UserContext);

    const handleLogout = async () => {
        await SubmitSession(setIsToggled)
        setState(null); // Update context to null
        window.localStorage.removeItem("auth"); // Clear local storage
        window.location.href = "/login"; // Redirect to login page
        toast.success("User LoggedOut Successfully"); // Show success message
    };

    return (
        <button
            onClick={handleLogout}
            className="flex px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">
            <FaArrowRightFromBracket className='mt-1 mr-1' />Logout
        </button>
    );
};

export default UserLogout;
